import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateTime } from 'luxon';

import { BaseListDomainService } from '@common/domain/base-list-domain.service';
import { DatesService } from '@common/services/dates.service';
import { ResultApi } from '@common/api/result-api';
import { VbrSuccessRateListApiService } from '@apps/bckp/api/veeam/vbr/vbr-successrate-list-api.service';
import { StatusPerDay, Status } from '../../models';
import { VbrRatesApi } from '@apps/bckp/api/models/vbr-rates-api';

@Injectable({
    providedIn: 'root'
})
export class VbrSuccessRateListDomainService extends BaseListDomainService
{
    constructor (
        private vbrSuccessRateListApiService: VbrSuccessRateListApiService,
        private datesService: DatesService
    )
    {
        super();
    }

    getStatusPerRange (since: DateTime, until: DateTime): Observable<StatusPerDay[]>
    {
        return this.getSuccessRates(since, until);
    }

    getLastSession (since: DateTime, until: DateTime): Observable<Status[]>
    {
        const init: Status[] = [0, 1, 2].map((idx: number) => new Status(idx, 0, idx));

        return this.getSuccessRates(since, until)
            .pipe(
                map((successRates: StatusPerDay[]) =>
                    successRates.reduce((prev: Status[], curr: StatusPerDay) =>
                    {
                        for (let idx = 0; idx < 3; idx++)
                        {
                            prev[idx].counter += curr.groupByCodeStatuses[idx].counter;
                        }

                        return prev;

                    }, init))
            );
    }

    getSuccessRates (since: DateTime, until: DateTime): Observable<StatusPerDay[]>
    {
        const range: string = this.datesService.RawUtcDateRange(since, until);

        return this.vbrSuccessRateListApiService.getDailyRates(range)
            .pipe(
                map((obj: ResultApi<VbrRatesApi>): VbrRatesApi[] =>
                    obj.value
                ),
                map((result: VbrRatesApi[]) =>
                    result.map<StatusPerDay>(vbr => StatusPerDay.mapperFromVbrRates(vbr))
                )
            );
    }
}
